import React from "react";
import { NavLink } from "react-router-dom";

function CategoryMonth({ value }) {
  return (
    <>
      <section className="container py-5">
        <div className="row text-center pt-3">
          <div className="col-lg-6 m-auto">
            <h1 className="h1">Categories of The Month</h1>
            <p>
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est laborum.
            </p>
          </div>
        </div>
        <div className="row">
          {value.map((valuee) => {
            return (
              <div className="col-12 col-md-4 p-5 mt-3" key={valuee.id}>
                <NavLink to="/ProductDetails" >
                  <img
                    src={valuee.img}
                    className="rounded-circle img-fluid border"
                    alt="img.jpg"
                  />
                </NavLink>
                <h5 className="text-center mt-3 mb-3">{valuee.Namee}</h5>
                <p className="text-center">
                  <NavLink to="/ProductDetails" className="btn btn-success">Go Shop</NavLink>
                </p>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}

export default CategoryMonth;
